import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import styles from './Popover.module.scss';

function PopoverComponent({ trigger, bodyForm, isMoveApplied, setIsMoveApplied, setInputValue }) {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const popoverRef = useRef(null);

    const handleClickOutside = useCallback((event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsFocused(false);
            setInputValue('');
        }
    }, [setInputValue]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

    const handleMouseEnter = useCallback(() => {
        setIsHovered(true);
        if (isMoveApplied) {
            setIsMoveApplied(false); // reset
        }
    }, [isMoveApplied, setIsMoveApplied]);

    const handleMouseLeave = useCallback(() => {
        setIsHovered(false);
    }, []);

    const handleContentFocused = useCallback(() => {
        if (!isFocused) {
            setIsFocused(true);
        }
    }, [isFocused]);

    const shouldShowPopover = useMemo(() => {
        return (isHovered || isFocused) && !isMoveApplied;
    }, [isHovered, isFocused, isMoveApplied]);

    return (
        <div
            className={styles.popover}
            ref={popoverRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={styles.popoverTrigger}>
                {trigger}
            </div>

            <div className={`${styles.popoverBody} ${shouldShowPopover ? styles.popoverBodyVisible : styles.popoverBodyHidden}`}>
                <div
                    className={styles.popoverContent}
                    onClick={handleContentFocused}
                >
                    {bodyForm && <div className={styles.popoverForm}>{bodyForm}</div>}
                </div>
            </div>
        </div>
    );
}

function areEqual(prevProps, nextProps) {
    return (
        prevProps.isMoveApplied === nextProps.isMoveApplied &&
        prevProps.trigger === nextProps.trigger &&
        prevProps.bodyForm === nextProps.bodyForm
    );
}

export default React.memo(PopoverComponent, areEqual);
